<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" title="结构物健康监测-经典案例" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div class="case-section-content-list" v-for="(cas,index) in caseList" :key="index">
          <img v-lazy="cas.Img" />
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.Title}}</p>
            <p class="abstract-content">{{cas.Content}}</p>
            <!-- <div class="more">
              <router-link
                class="text-decoration"
                :to="{ name: 'case', params: { id: cas.Id }}"
              >
                <span>more</span>
                <img src="../assets/img/sanjiao.png" />
              </router-link>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: false,
      caseList: [{
		Img:'https://file.jxth.com.cn/group1/M00/00/19/dSm0ymCWKfiADY4ZAAQhxZVT6ZI133.jpg',
		Title:'江西省信江航电枢纽项目',
		Content:'2019年5月，江西省创建公路水运品质工程推进会在信江航电枢纽项目现场顺利召开，江西省交通运输厅副厅长王昭春、省交通质监局局长彭东领等领导出席会议，重点是推动运用信息化手段进行科学管理。通慧科技作为物联网智慧工地的实施单位参与建设，并承担了江西省交通运输厅的研究课题“分布式光纤在大坝监测中应用”。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M03/00/23/dSm0ymCvQVeAf5DTAArT8LEAlV0528.png',
		Title:'前进大桥',
		Content:'2019年10月，我司针对上饶30多年的拱桥，前进大桥进行了健康监测设备安装及监测服务。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M01/00/23/dSm0ymCvRBOAQA9WABpEyWDLx48935.png',
		Title:'浙江省甬台温高速公路',
		Content:'2019年6月，浙江省甬台温高速公路全线贯通。甬台温高速公路路线全长252.7公里，是国内迄今为止最长的软基地质高速公路项目。通慧科技承担了高边坡和软基监测任务，采用了分布式光纤监测技术。'
	  },
	  {
		Img:'https://file.jxth.com.cn/group1/M03/00/23/dSm0ymCvRX-ATPIkABBRTOYBfaY493.png',
		Title:'抚州市赣东大桥',
		Content:'2020年8月，我司承担了赣东大桥主桥健康监测系统的安装及2年的运营维护工作。抚州市赣东大桥起点桩号为K0+462，终点桩号为K1+022，中心桩号为K0+742，桥梁全长560m，跨径组成：4×35m+264m+4×35m，主桥为264m的独塔双索面预应力混凝土斜拉桥，采用塔梁固结体系，主梁与主塔固结。南北两侧引桥采用4×35m装配式部分预应力混凝土连续箱梁（先简支后结构连续）。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M01/00/23/dSm0ymCvSiyASErTABpZrMLhU6Y315.png',
		Title:'赣州龙南科技示范路',
		Content:'赣州龙南科技示范路项目以上三处边坡均属于严重地质灾害点，进行表面位移、水位、深层位移稳定性监测。边坡稳定性监测系统是解决边坡稳定问题、查清边坡变形破坏机理和范围、防治地质灾害的有效和必要手段，通过自动化监测可以预防边坡地质灾害、保障施工运营安全、保护环境，优化边坡地质灾害治理设计和施工方案、节约造价，对滑坡等地质灾害进行预警。'
	  }]
    };
  },
  mounted() {
	  
  }
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 400px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 350px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 200px;
			line-height: 1.5;
            color: #484848;
            font-size: 15px;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // display: -webkit-box;
            // -webkit-line-clamp: 18;
            // -webkit-box-orient: vertical;
            // white-space: normal !important;
            // word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>